"use client";

import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
interface FieldTogglePillsProps {
  fields: Array<{
    id: string;
    name: string;
    color: string;
  }>;
  selected: Set<string>;
  onToggle: (fieldId: string) => void;
}
export default function FieldTogglePills(t0) {
  const $ = _c(11);
  const {
    fields,
    selected,
    onToggle
  } = t0;
  let t1;
  let t2;
  if ($[0] !== fields || $[1] !== onToggle || $[2] !== selected) {
    const uniqueFields = fields.filter(_temp);
    t1 = "flex flex-wrap gap-2";
    let t3;
    if ($[5] !== onToggle || $[6] !== selected) {
      t3 = field_0 => <button key={field_0.id} type="button" onClick={() => onToggle(field_0.id)} className={cx("rounded-full px-2.5 py-1 text-caption-strong transition-colors", selected.has(field_0.id) ? "bg-primary text-primary-foreground" : "bg-background-secondary text-foreground-secondary hover:bg-hover")}><span className="mr-1.5 inline-block h-2 w-2 rounded-full" style={{
          backgroundColor: field_0.color
        }} />{field_0.name}</button>;
      $[5] = onToggle;
      $[6] = selected;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = uniqueFields.map(t3);
    $[0] = fields;
    $[1] = onToggle;
    $[2] = selected;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(field, index, allFields) {
  return allFields.findIndex(candidate => candidate.id === field.id) === index;
}